export class DocumentGroupQueryModel {
  ParentObjectName: string;
  ObjectId: string;
  PatientId: string;
  DocumentId: string;
}
